export interface ConfigQuanto {
  recId: number;
  symbol: string;
  isHardCoded: boolean;
  secondSymbol: string | null;
  nonTradingDayFillMethod: string | null;
  nonTradingDayFillOption: string | null;
}

export interface ConfigQuantoBatchRequest {
  added: ConfigQuanto[];
  modified: ConfigQuanto[];
  deleted: number[];
}

// Coded tokens the valuation calc engine understands. Kept as constants so the
// edit dropdowns stay in sync with the engine; extend here when a new token is
// introduced. Empty string = "none" (stored as NULL by the backend).
export const NON_TRADING_DAY_FILL_METHODS = ['', 'ALL_CALENDAR_DAYS'] as const;
export const NON_TRADING_DAY_FILL_OPTIONS = ['', 'PREVIOUS_VALUE'] as const;
